import { html, LitElement, TemplateResult } from "lit";
import { customElement, property, query } from "lit/decorators.js";

export interface SelectOption {
    value: string;
    label: string;
    disabled: boolean;
}

@customElement('select-input')
export class SelectInput extends LitElement {

    // Props

    @property({ type: Boolean, reflect: true })
    disabled: boolean = false;

    @property({ type: Boolean, reflect: true })
    required: boolean = false;

    @property({ type: String })
    name: string = '';

    @property({ type: String })
    value?: string = null;

    @property({ type: String })
    label: string = 'Select an Option';

    @property({ type: Array })
    options: SelectOption[] = [];

    @query('select')
    _select?: HTMLSelectElement;

    // Lifecycle Hooks

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('SelectInput');
    }

    // Render

    render() {
        return html`
            <select 
                class="SelectInput-select"
                name="${ this.name }"
                ?required="${ this.required }"
                @change="${ this._handleChange }">
                <option  
                    disabled
                    ?selected="${ !this.value }">
                    ${ this.label }
                </option>
                ${ this.options.map((option) => this.optionTemplate(option)) }
            </select>
            <div class="SelectInput-icon">
                <svg-icon name="downCaret"></svg>
            </div>
        `;
    }

    createRenderRoot() { 
        return this;
    }

    // Templates

    optionTemplate(option: SelectOption): TemplateResult {
        return html`
            <option 
                value="${ option.value }"
                ?disabled="${ option.disabled }"
                ?selected="${ this.value && this.value == option.value }">
                ${ option.label }
            </option>
        `;
    }

    // Methods

    private _handleChange() {
        this.value = this._select.value;
        const event = new Event('change');
        this.dispatchEvent(event);
    }

}